export default "__VITE_ASSET__DfHOzCvA__"